// extracted by mini-css-extract-plugin
export default {"container":"previousBill_container__3AjFu","noBills":"previousBill_noBills__ITZyx"};